import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { DesktopMac } from '@mui/icons-material';
import { useL10n } from '@uplift/hooks';
import { Modal, ModalActions, ModalContent, ModalProgressButton } from '@uplift/ui-v2';

export type BetterDesktopExperienceProps = {
  isMobile: boolean;
  handleClick: () => void;
};

export const BetterDesktopExperience: React.VFC<BetterDesktopExperienceProps> = ({ handleClick }) => {
  const { classes } = useStyles();
  const l10n = useL10n();

  return (
    <Modal
      open
      fullWidth
      maxWidth="sm"
      showCloseIcon={false}
      classes={{ paperWidthSm: classes.paperWidthSm, paper: classes.paper }}
    >
      <ModalContent>
        <Box className={classes.desktop} gap="24px" mt={-2} mb={-3}>
          <DesktopMac className={classes.icon} />
          <Box display="flex">
            <Typography variant="body2" className={classes.message} >{l10n.providerSettings.onboarding.experienceIsBetterOnDesktop}</Typography>
          </Box>
        </Box>
      </ModalContent>
      <ModalActions className={classes.actionButton}>
        <ModalProgressButton variant="contained" color="secondary" onClick={handleClick}>
          {l10n.general.gotIt}
        </ModalProgressButton>
      </ModalActions>
    </Modal>
  );
};

const useStyles = makeStyles()(theme => ({
  desktop: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    alignContent: 'center',
  },
  message: {
    color: theme.palette.text.primary,
    fontWeight: 400,
    textAlign: 'center',
  },
  paperWidthSm: {
    maxWidth: '282px',
  },
  icon: {
    fontSize: '40px'
  },
  actionButton: {
    display: 'flex',
    justifyContent: 'center',
  },
  centerText: {
    textAlign: 'center',
  },
  paper: {
    position: 'absolute',
    top: '150px'
  }
}));
